function SignalRHelper() {
	var signalRHelper = this;
	
	signalRHelper.connectionHelper = new SignalRConnectionHelper('https://signalr.hendersonengineers.com/signalr/hubs');
	signalRHelper._hubs = {};
	signalRHelper._registeredEvents = {};
	signalRHelper._wrappedHandlerMap = new Map();
	signalRHelper._activeHubs = new Set();
	signalRHelper._hubsThatHaveBeenActivated = new Set();
	signalRHelper._clientToClientPromiseIdToPromise = {};
	signalRHelper._registeredCount = {};
	signalRHelper.whenConnected = $.Deferred();
	signalRHelper.retryCounter = 0.5;
  
	signalRHelper.connectionHelper.connection.stateChanged(function (state) {    
		signalRHelper._startIfNeeded(signalRHelper.connectionHelper, state);	
	});
	
	for (var i = 0; i < arguments.length; i++) {
		if (arguments[i] == null) {
			continue;
		}

		signalRHelper.connect(arguments[i])
	}

	signalRHelper.Clients = new Clients(signalRHelper);
	
	return signalRHelper;
};

SignalRHelper.prototype.isSignalRHelper = true;

SignalRHelper.prototype.cleanConnectionUrl = function(url) {
	return url.replace(/\\/g, '/').replace(/^\//, '').replace(/\/$/, '').toLowerCase();
}

SignalRHelper.prototype.connect = function(hubName) {
	var signalRHelper = this;
	
	if (!hubName) {
		console.error(Eror('Must provide a hub to connect to!'));
		return signalRHelper;
	}
	
	if (!$.connection.hasOwnProperty(hubName)) {
		console.error(Error('The hub "' + hubName + '" does not exist'));
		return signalRHelper;
	}
	
	if (!signalRHelper._hubs.hasOwnProperty(hubName)) {  
		var hub = signalRHelper.connectionHelper.connection.createHubProxy(hubName);

		signalRHelper._hubs[hubName] = hub;	
    
    if (!signalRHelper._registeredEvents.hasOwnProperty(hubName)) {
      signalRHelper._registeredEvents[hubName] = {};
    }
		
		signalRHelper.on('reconnected', function () {
			try {
				signalRHelper.emit(hubName, 'AddConnection', signalRHelper.connectionHelper.id);
			}
			catch (ex) { };
		}, hubName)
    
    if (!window.signalRConnectionHelpers) {
      window.signalRConnectionHelpers = {};
    }
    
    if (!window.signalRConnectionHelpers[hubName]) {
      window.signalRConnectionHelpers[hubName] = [];
    }
    
    window.signalRConnectionHelpers[hubName].push(signalRHelper.connectionHelper);
	}

	return signalRHelper;
};

SignalRHelper.prototype.start = function(hubName) {
	var signalRHelper = this;

	var needToStart = true;
  var needToRestart = false;
  var willRestart = false;
  var hubsToActivate = [];

	if (signalRHelper._activeHubs.size > 0) {
		var activeHubs = Array.from(signalRHelper._activeHubs);

		for (var i = 0; i < activeHubs.length; i++) {
			if (needToStart && signalRHelper._hubs.hasOwnProperty(activeHubs[i])) {
				needToStart = false;
				break;
			}
		}
	}
  
	if (hubName) {		
		needToRestart = !needToStart && !signalRHelper._activeHubs.has(hubName);
    
    if (!signalRHelper._activeHubs.has(hubName)) {
      hubsToActivate.push(hubName);
    }
    
		signalRHelper._activateHub(hubName);
	}
	else {
		// start all connected hubs
		
		for (var hubName in signalRHelper._hubs) {
			needToRestart = needToRestart || (!needToStart && !signalRHelper._activeHubs.has(hubName))
      
      if (!signalRHelper._activeHubs.has(hubName)) {
        hubsToActivate.push(hubName);
      }
      
			signalRHelper._activateHub(hubName);
		}
	}
	
	if (needToStart) {	
    signalRHelper.connectionHelper.connection.start()
      .done(function () {
        signalRHelper.retryCounter = 0.5;
        
        signalRHelper.connectionHelper.whenConnected.resolve(true);
        signalRHelper.connectionHelper.whenCanEmit.resolve(true);
      })
      .fail(function (err) { 
        console.log('SignalR could not connect: ' + err); 
        
        signalRHelper.connectionHelper.whenConnected.resolve(false);
        signalRHelper.connectionHelper.whenCanEmit.resolve(false);
      });
		
		$.when(signalRHelper.connectionHelper.whenConnected).then(function (connectionResult) {
			if (connectionResult) {
				signalRHelper.whenConnected.resolve();
			}
			else {
				signalRHelper.whenConnected.reject();
			}
		});
	}
	else if (needToRestart) {
		willRestart = signalRHelper._restart();
	}
  
  if (!willRestart && hubsToActivate.length > 0) {  
    signalRHelper._waitForConnected().then(function (connectionResult) {
      if (connectionResult) {
        for (var i = 0; i < hubsToActivate.length; i++) {
          signalRHelper.emit(hubsToActivate[i], 'AddConnection', signalRHelper.connectionHelper.id)
        }
      }
    });
  }
	
	return signalRHelper;
};

SignalRHelper.prototype._waitForConnected = function() {
  var signalRHelper = this;
  
  if (signalRHelper.connectionHelper.connection.state === $.connection.connectionState.connecting || signalRHelper.connectionHelper.connection.state === $.connection.connectionState.reconnecting) {
    return new Promise(function(resolve) {
      var counter = 1;
      var interval = setInterval(function() {
        if (signalRHelper.connectionHelper.connection.state === $.connection.connectionState.connected || counter === 12) { // wait for at most 3 seconds
          clearInterval(interval);
          resolve(signalRHelper.connectionHelper.connection.state === $.connection.connectionState.connected);
        }
        
        counter++;
      }, 250);
    });
  }
  
  return Promise.resolve(true);
}

SignalRHelper.prototype.stop = function(hubName) {
	var signalRHelper = this;
	
	if (hubName) {
		signalRHelper._deactivateHub(hubName);
	}
	else {
		// stop all connected hubs
		
		for (var hubName in signalRHelper._hubs) {
			signalRHelper._deactivateHub(hubName);
		}
	}
	
	var needToStopPrimaryConnection = true;
	
	if (signalRHelper._activeHubs.size > 0) {
		var activeHubs = Array.from(signalRHelper._activeHubs);
		
		for (var i = 0; i < activeHubs.length; i++) {
			if (needToStopPrimaryConnection && signalRHelper._hubs.hasOwnProperty(activeHubs[i])) {
				needToStopPrimaryConnection = false;
				break;
			}
		}
	}
	
	if (needToStopPrimaryConnection) {
		signalRHelper.connectionHelper._forceStop = true;
		signalRHelper.connectionHelper.connection.stop();
	}
	
	return signalRHelper;
};

SignalRHelper.prototype.on = function(event, eventHandler, hubName) {	
	var signalRHelper = this;
	
	if (!event) {
		console.error(Error('Must provide an event to bind to!'));
		return signalRHelper;
	}
	
	if (typeof eventHandler !== 'function') {
		console.error(Error('eventHandler must be a function!'));
		return signalRHelper;
	}
	
	var hub = this._getHub(hubName);
  
  if (!hub) {
    console.error(Error('The hub "' + hubName + '" does not exist'));
    return signalRHelper;
  }
	
	var func = signalRHelper._dynamicallyNameFunction(signalRHelper._generateUniqueFunctionName(), function () {		
		var callerData = arguments.length > 0 && arguments[arguments.length - 1] && arguments[arguments.length - 1].constructor === Object && arguments[arguments.length - 1].hasOwnProperty('callerPromiseIdChain') ? arguments[arguments.length - 1] : null;
		var invokingCall = signalRHelper._getInvokingCall(callerData);
		
		if (invokingCall) {
			var parameters = [];
			
			for (var i = 0; i < arguments.length; i++) {
				parameters.push(arguments[i]);
			}
			
			invokingCall.done(function () {
				invokingCall.recipients.delete(callerData.from);
				parameters.push(invokingCall.recipients.size === 0);
				eventHandler.apply(eventHandler, parameters);
			});
		}
		else {
			eventHandler.apply(eventHandler, arguments);
		}
	});

	if (!signalRHelper._registeredEvents[hub.hubName]) {
		signalRHelper._registeredEvents[hub.hubName] = {};
	}
	
	if (!signalRHelper._registeredEvents[hub.hubName][event]) {
		signalRHelper._registeredEvents[hub.hubName][event] = [];
	}

	signalRHelper._registeredEvents[hub.hubName][event].push(func);
	signalRHelper._wrappedHandlerMap.set(eventHandler, func);

	hub.on(event, func);
	
	return signalRHelper;
};

SignalRHelper.prototype.off = function(event, eventHandler, hubName) {
	var signalRHelper = this;

	if (!event) {
		console.error(Error('Must provide an event to bind to!'));
		return signalRHelper;
	}
	
	var hub = signalRHelper._getHub(hubName);
  
  if (!hub) {
    console.error(Error('The hub "' + hubName + '" does not exist'));
    return signalRHelper;
  }

	if (eventHandler && typeof eventHandler === 'function') {
		var func = signalRHelper._wrappedHandlerMap.get(eventHandler);
		var newEvents = (signalRHelper._registeredEvents[hub.hubName][event] || []).filter(function(handler) { return handler !== func });

		signalRHelper._registeredEvents[hub.hubName][event] = newEvents;
		hub.off(event, func);		
	}
	else {
		delete signalRHelper._registeredEvents[hub.hubName][event];
		hub.off(event);
	}

	signalRHelper._wrappedHandlerMap.delete(eventHandler);
	
	return signalRHelper;
};

SignalRHelper.prototype.emit = function() {
	var signalRHelper = this;
	
	var hubName = arguments[0];
	var eventIndex = 1;
	
	if (!$.connection.hasOwnProperty(hubName)) {
		var allHubs = Object.keys(signalRHelper._hubs);
		
		if (allHubs.length === 1) {
			hubName = allHubs[0];
			eventIndex = 0;
		}
		else {
			console.error(Error('You must provide a hub name as the first argument if you have connected to more than 1 hub. Registered hubs: ' + allHubs.join(', ')));
			return;
		}
	}
	
	var hub = signalRHelper._hubs[hubName];

	if (!hub) {
		console.error(Error('The hub "' + hubName + '" has not been registered with this helper. Registered hubs: ' + Object.keys(signalRHelper._hubs).join(', ')));
		return;
	}
	
	if (!signalRHelper._activeHubs.has(hubName)) {
		console.error(Error('The hub "' + hubName + '" is currently stopped'));
		return;
	}
	
	//convert the event name to camel case if it isn't already
	var event = arguments[eventIndex].replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
		return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
	}).replace(/\s+/g, '');
	
	if (!$.connection[hubName].server.hasOwnProperty(event)) {
		if (/AddConnection/i.test(event)) {
			throw Error();
		}
		else {
			var allServerMethods = new Set(Object.keys(signalRHelper.Clients._serverFunctionNames).map(function (clientMethod) { return signalRHelper.Clients._serverFunctionNames[clientMethod]; }));
			console.error(Error(allServerMethods.has(arguments[eventIndex]) ? 'You can only use client-to-client communication if you are using TrackableHub as your Hub\'s base class!' : 'The event "' + arguments[eventIndex] + '" does not exist within the hub "' + hubName + '"'));
			return;
		}
	}
	
	var invokeParams = [ event ];
	for (var i = (eventIndex + 1); i < arguments.length; i++) {
		invokeParams.push(arguments[i]);
	}
	
	var eventArgumentsString = $.connection[hubName].server[event].toString().match(/function.+\((.*)\)/);
	if (eventArgumentsString !== null && eventArgumentsString.length > 1) {
		var eventArguments = eventArgumentsString[1].split(/, ?/).filter(function(eventArg) { return !!eventArg });
		
		var missingParams = [];
		for(var i = 0; i < eventArguments.length; i++) {
			if (invokeParams[i + 1] === undefined) {
				if (eventArguments[i].toLowerCase() === 'clientconnectionid') {
					invokeParams.push(signalRHelper.connectionHelper.id);
				}
				else {
					missingParams.push(eventArguments[i]);
				}
			}
		}
		
		if (missingParams.length > 0) {
			console.error(Error('Missing parameter' + (missingParams.length === 1 ? ' ' : 's ') + missingParams.join(', ') + ' for event "' + arguments[0] + '"'));
			return;
		}
	}
	
	var promise = $.Deferred();
	
	$.when(signalRHelper.connectionHelper.whenCanEmit).then(function (connectionResult) {
		if (connectionResult) {
			hub.invoke.apply(hub, invokeParams)
				.done(function () {
					promise.resolve.apply(signalRHelper, arguments);
				})
				.fail(function () {
					promise.reject.apply(signalRHelper, arguments);
				})
		}
		else {
			console.error(Error('at least one connection was not started correctly, cannot emit until all connections are started'));
			return;
		}
	});
	
	return promise;
};

SignalRHelper.prototype.register = function(hubName) {
	var signalRHelper = this;

	if (!$.connection.hasOwnProperty(hubName)) {
		var allHubs = Object.keys(signalRHelper._hubs);

		if (allHubs.length === 1) {
			hubName = allHubs[0];
		}
		else {
			console.error(Error('You must provide a hub name as the first argument if you have connected to more than 1 hub. Registered hubs: ' + allHubs.join(', ')));
			return signalRHelper;
		}
	}

	if (!signalRHelper._registeredCount.hasOwnProperty(hubName)) {
		signalRHelper._registeredCount[hubName] = 0;
	}

	signalRHelper._registeredCount[hubName]++;

	return signalRHelper;
};

SignalRHelper.prototype.unregister = function(hubName) {
	var signalRHelper = this;

	if (!$.connection.hasOwnProperty(hubName)) {
		var allHubs = Object.keys(signalRHelper._hubs);

		if (allHubs.length === 1) {
			hubName = allHubs[0];
		}
		else {
			console.error(Error('You must provide a hub name as the first argument if you have connected to more than 1 hub. Registered hubs: ' + allHubs.join(', ')));
			return signalRHelper;
		}
	}

	if (!signalRHelper._registeredCount.hasOwnProperty(hubName)) {
		signalRHelper._registeredCount[hubName] = 0;
	}

	signalRHelper._registeredCount[hubName] = Math.max(0, this._registeredCount[hubName] - 1);

	return signalRHelper;
};

SignalRHelper.prototype.stopIfNoneRegistered = function(hubName) {
	var signalRHelper = this;

	if (!$.connection.hasOwnProperty(hubName)) {
		var allHubs = Object.keys(signalRHelper._hubs);

		if (allHubs.length === 1) {
			hubName = allHubs[0];
		}
		else {
			console.error(Error('You must provide a hub name as the first argument if you have connected to more than 1 hub. Registered hubs: ' + allHubs.join(', ')));
			return signalRHelper;
		}
	}

	if (!signalRHelper._registeredCount.hasOwnProperty(hubName) || signalRHelper._registeredCount[hubName] === 0) {
    signalRHelper.stop(hubName);
	}

	return signalRHelper;
};

SignalRHelper.prototype.destroy = function() {
	this.stop();
  this._hubs = {};
	this._activeHubs = new Set();
	this._registeredEvents = {};
	this._wrappedHandlerMap = new Map();
	this._hubsThatHaveBeenActivated = new Set();
	this._clientToClientPromiseIdToPromise = {};
	this._registeredCount = {};
	
	return null;
};

SignalRHelper.prototype.reset = function (persistRetryCounter) {  
  var signalRHelper = this;
  
  var activeHubs = Array.from(signalRHelper._activeHubs);
  var registeredEvents = signalRHelper._registeredEvents;
  var registeredCount = signalRHelper._registeredCount;
  
  signalRHelper.destroy();
	
	signalRHelper.connectionHelper = new SignalRConnectionHelper('https://signalr.hendersonengineers.com/signalr/hubs');
	signalRHelper.whenConnected = $.Deferred();
  signalRHelper._registeredEvents = registeredEvents;
  signalRHelper._registeredCount = registeredCount;
  
  if (!persistRetryCounter) {
    signalRHelper.retryCounter = 0.5;
	}
  
	signalRHelper.connectionHelper.connection.stateChanged(function (state) {    
		signalRHelper._startIfNeeded(signalRHelper.connectionHelper, state);	
	});
	
	for (var i = 0; i < activeHubs.length; i++) {
		if (activeHubs[i] == null) {
			continue;
		}

		signalRHelper.connect(activeHubs[i])
	}

	signalRHelper.Clients = new Clients(signalRHelper);
  
  signalRHelper.start();
	
	return signalRHelper;
};

SignalRHelper.prototype._getHub = function(hubName) {
	if (!hubName) {
		var allHubs = Object.keys(this._hubs);
		
		if (allHubs.length === 1) {
			hubName = allHubs[0];
		}
		else {
			console.error(Error('You must provide a hub name if you have connected to more than 1 hub. Registered hubs: ' + allHubs.join(', ')));
			return;
		}
	}
	
	if (!$.connection.hasOwnProperty(hubName)) {
		console.error(Error('The hub "' + hubName + '" does not exist'));
		return;
	}
	
	var hub = this._hubs[hubName];
	
	if (!hub) {
		console.error(Error('The hub "' + hubName + '" has not been registered with this helper. Registered hubs: ' + Object.keys(this._hubs).join(', ')));
		return;
	}
  
  hub.hubName = hubName;
	return hub;
}

SignalRHelper.prototype._activateHub = function(hubName) {
	var hub = this._getHub(hubName);
  
  if (!hub) {
    console.error(Error('The hub "' + hubName + '" does not exist'));
    return;
  }
	
	if (this._activeHubs.has(hub.hubName)) {
		return;
	}
	
	var hubEvents = this._registeredEvents[hub.hubName];
	for (var event in hubEvents) {
		if (hubEvents.hasOwnProperty(event)) {
			var handlers = hubEvents[event];

			if (handlers) {
				handlers.forEach(function(handler) {
					hub.off(event, handler).on(event, handler);
				});
			}			
		}
	}
	
	this._activeHubs.add(hub.hubName);
	this._hubsThatHaveBeenActivated.add(hub.hubName);
};

SignalRHelper.prototype._deactivateHub = function(hubName) {
	var hub = this._getHub(hubName);
	
	if (!this._activeHubs.has(hubName)) {
		return;
	}
	
	var hubEvents = this._registeredEvents[hub.hubName];
	for (var event in hubEvents) {
		if (hubEvents.hasOwnProperty(event)) {
			var handlers = hubEvents[event];
			
			if (handlers) {
				handlers.forEach(function(handler) {
					hub.off(event, handler);
				});
			}
		}
	}
	
	this._activeHubs.delete(hub.hubName);
};

SignalRHelper.prototype._restart = function() {
	var signalRHelper = this;
  
  if (signalRHelper.connectionHelper.connection.state === $.connection.connectionState.disconnected) {
    return false;
  }
	
	if (window.resetSignalRConnectionTimer != null) {
		clearTimeout(window.resetSignalRConnectionTimer);
		window.resetSignalRConnectionTimer = null;
	}
	
	window.resetSignalRConnectionTimer = setTimeout(function() {
		window.resetSignalRConnectionTimer = null;
    
    signalRHelper._waitForConnected().then(function (connectionResult) {
      signalRHelper.reset();
    });
	}, 250);
  
  return true;
};

SignalRHelper.prototype._startIfNeeded = function (connectionHelper, state) {
	var signalRHelper = this;
	var accessToken = HEIJS.getAccessToken();
	signalRHelper.connectionHelper.connection.qs = { 'access_token': accessToken };
	
	if (state.newState === $.connection.connectionState.disconnected) {
		if (!connectionHelper._forceStop) {
			setTimeout(function() { 
        signalRHelper.reset(true);
      }, 500 * signalRHelper.retryCounter);
      
      if (signalRHelper.retryCounter < 120) {
        if (signalRHelper.retryCounter === 0.5) {
          signalRHelper.retryCounter = 1;
        }
        else {
          signalRHelper.retryCounter++;
        }
      }
		}
    
		connectionHelper._forceStop = false;
	}
};

SignalRHelper.prototype._getConnectedHubs = function() {
	var signalRHelper = this;
  
  var connectedHubs = new Set();
  
  try {
    JSON.parse(signalRHelper.connectionHelper.connection.data).forEach(function(hub) {
      connectedHubs.add(hub.name);
    });
  }
	catch(ex) {}
  
  return connectedHubs;
};


SignalRHelper.prototype._getInvokingCall = function (callerData) {
  var signalRHelper = this;
	var callerPromiseIdChain = !!callerData ? callerData.callerPromiseIdChain : null;
	
	if (callerPromiseIdChain) {
		//run up the chain to find the call that this client made
		
		for (var i = callerPromiseIdChain.length - 1; i >= 0; i--) {
			if (signalRHelper._clientToClientPromiseIdToPromise.hasOwnProperty(callerPromiseIdChain[i])) {
				return signalRHelper._clientToClientPromiseIdToPromise[callerPromiseIdChain[i]];
			}
		}
	}
	
	return null;
};

SignalRHelper.prototype._getCallerPromiseIdChain = function (callerArgs) {
	if (callerArgs && callerArgs.length > 0) {
		var callerData = callerArgs[callerArgs.length - 1];
		
		if (callerData.constructor === Object) {
			return callerData.callerPromiseIdChain;
		}
	}
	
	return null;
};

SignalRHelper.prototype._pseudoDirectClientCommunication = function (serverFunctionName, messageNameOrHub) {
  var signalRHelper = this;
  
  var messageNameIndex = 1;
  var callArgs = [];
  var hubName = undefined;
  
  if (signalRHelper._hubs.hasOwnProperty(messageNameOrHub)) {
    callArgs.push(messageNameOrHub);
    hubName = messageNameOrHub;
    messageNameIndex++;
  }
  
  callArgs.push(serverFunctionName);
  callArgs.push(arguments[messageNameIndex]);
  callArgs.push(signalRHelper._createParameterArray(arguments, messageNameIndex + 1));
  
  return signalRHelper._emitPseudoDirectClientCommunicationMessage(callArgs, arguments[arguments.length - 1]);
};

SignalRHelper.prototype._pseudoDirectSpecificClientsCommunication = function (connectionIds, serverFunctionName, messageNameOrHub) {
  var signalRHelper = this;
  
  var messageNameIndex = 2;
  var callArgs = [];
  var hubName = undefined;
  
  if (signalRHelper._hubs.hasOwnProperty(messageNameOrHub)) {
    callArgs.push(messageNameOrHub);
    hubName = messageNameOrHub;
    messageNameIndex++;
  }
  
  callArgs.push(connectionIds);
  callArgs.push(serverFunctionName);
  callArgs.push(arguments[messageNameIndex]);
  callArgs.push(signalRHelper._createParameterArray(arguments, messageNameIndex + 1));
  
  return signalRHelper._emitPseudoDirectClientCommunicationMessage(callArgs, arguments[arguments.length - 1]);
};

SignalRHelper.prototype._createParameterArray = function (params, startIndex) {
  var parameters = [];
  
  for (var i = startIndex; i < params.length - 1; i++) {
    parameters.push(params[i]);
  }
  
  return parameters;
};

SignalRHelper.prototype._emitPseudoDirectClientCommunicationMessage = function (callArgs, callerPromiseIdChain) {
  var signalRHelper = this;
	
  var promise = $.Deferred();
	var promiseId = signalRHelper.connectionHelper._generateUUID();
	
	signalRHelper._clientToClientPromiseIdToPromise[promiseId] = promise;
	
	if (!callerPromiseIdChain) {
		callerPromiseIdChain = [ promiseId ];
	}
	else {
		callerPromiseIdChain.push(promiseId);
	}
	
	callArgs.push(callerPromiseIdChain);
	
  signalRHelper.whenConnected.always(function () {
		try {
			signalRHelper.emit.apply(signalRHelper, callArgs)
				.done(function (sentTo) {
          var uniqueSentTo = new Set(sentTo);
					promise.recipients = uniqueSentTo;
					promise.resolve(uniqueSentTo);
				})
				.fail(function (err) {
					promise.reject.apply(signalRHelper, arguments);
				});
		}
		catch (err) { 
			promise.reject(err);
		}
  });
	  
  return promise; 
};

SignalRHelper.prototype._generateUniqueFunctionName = function () {
  return 'func_xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

SignalRHelper.prototype._dynamicallyNameFunction = function (name, fn) {
	return (
		new Function("return function (call) { return function " + name + " () { return call(this, arguments) }; };")()
	)(Function.apply.bind(fn));
};

function SignalRConnectionHelper(url) {
	this.id = this._generateUUID();
	var accessToken = HEIJS.getAccessToken();
	this.connection = $.hubConnection(HEIJS.context.convertToContextUri(url), { useDefaultPath: false, qs: { 'access_token': accessToken } });
	this.whenConnected = $.Deferred();
	this.whenCanEmit = $.Deferred();
	this._forceStop = false;
}

SignalRConnectionHelper.prototype._generateUUID = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

function Clients(signalRHelper) {
	this.signalRHelper = signalRHelper;
}

Clients.prototype.All = function All(messageNameOrHub) {
	var parameters = [ this._serverFunctionNames.All ];
	
	for (var i = 0; i < arguments.length; i++) {
		parameters.push(arguments[i]);
	}
	
	parameters.push(this.signalRHelper._getCallerPromiseIdChain(!!All.caller ? All.caller.arguments : null));
	
	return this.signalRHelper._pseudoDirectClientCommunication.apply(this.signalRHelper, parameters);
};

Clients.prototype.Others = function Others(messageNameOrHub) {
	var parameters = [ this._serverFunctionNames.Others ];
	
	for (var i = 0; i < arguments.length; i++) {
		parameters.push(arguments[i]);
	}
	
	parameters.push(this.signalRHelper._getCallerPromiseIdChain(!!Others.caller ? Others.caller.arguments : null));
	
	return this.signalRHelper._pseudoDirectClientCommunication.apply(this.signalRHelper, parameters);
};

Clients.prototype.Self = function Self(messageNameOrHub) {
	var parameters = [ this._serverFunctionNames.Self ];
	
	for (var i = 0; i < arguments.length; i++) {
		parameters.push(arguments[i]);
	}
	
	parameters.push(this.signalRHelper._getCallerPromiseIdChain(!!Self.caller ? Self.caller.arguments : null));
	
	return this.signalRHelper._pseudoDirectClientCommunication.apply(this.signalRHelper, parameters);
};

Clients.prototype.Client = function Client(connectionId, messageNameOrHub) {
	var parameters = [ this._serverFunctionNames.Client ];
	
	for (var i = 0; i < arguments.length; i++) {
		parameters.push(arguments[i]);
	}
	
	parameters.push(this.signalRHelper._getCallerPromiseIdChain(!!Client.caller ? Client.caller.arguments : null));
	
	return this.signalRHelper._pseudoDirectSpecificClientsCommunication.apply(this.signalRHelper, parameters);
};

Clients.prototype.Clients = function Clients(connectionIds, messageNameOrHub) {
	var parameters = [ this._serverFunctionNames.Clients ];
	
	for (var i = 0; i < arguments.length; i++) {
		parameters.push(arguments[i]);
	}
	
	parameters.push(this.signalRHelper._getCallerPromiseIdChain(!!Clients.caller ? Clients.caller.arguments : null));
	
	return this.signalRHelper._pseudoDirectSpecificClientsCommunication.apply(this.signalRHelper, parameters);
};

Clients.prototype.Caller = function Caller(messageNameOrHub) {		
	var callerArgs = Caller.caller ? Caller.caller.arguments : null;
	var callerData = callerArgs && callerArgs.length > 0 && callerArgs[callerArgs.length - 1].constructor === Object && callerArgs[callerArgs.length - 1].hasOwnProperty('callerPromiseIdChain') ? callerArgs[callerArgs.length - 1] : null;
	
	if (!callerData) {
		console.error(Error('Could not determine the originator of the message. This method can only be used in response to another message.'));
		return;
	}
	
	var parameters = [ this._serverFunctionNames.Client ];
	
	parameters.push(callerData.from);
	
	for (var i = 0; i < arguments.length; i++) {
		parameters.push(arguments[i]);
	}
	
	parameters.push(this.signalRHelper._getCallerPromiseIdChain(callerArgs));
	
	return this.signalRHelper._pseudoDirectSpecificClientsCommunication.apply(this.signalRHelper, parameters);
};
	
Clients.prototype._serverFunctionNames = Object.freeze({
	All: 'AllClients',
	Others: 'OtherClients',
	Self: 'SameClient',
	Client: 'SpecificClient',
	Clients: 'SpecificClients'
});
